import {getStore} from '../store'

/**
 * Tell the schedule board that what it loaded is now stale.
 *
 * The board holds the whole location's availability, fetched once per
 * location — and the availability editors are a nested route, so the board
 * stays mounted behind them and sees no location change on the way back.
 * Bumping the revision is what makes a save visible over there. Deliberately a
 * refetch rather than patching the board's copy from the editor: the server
 * re-normalizes what it is sent, so a refetch is the only version guaranteed
 * to match the DB.
 *
 * Written through getStore() rather than a hook — this runs from a save
 * handler, and the editor should not re-render on the board's own emits.
 */
export const markAvailabilityChanged = () => {
  const store = getStore()
  store.handleState(store.availabilityRevision + 1, 'availabilityRevision')
}
